import { StateCreator } from 'zustand';
import { ConfirmedSlice } from './confirmed.types';

export const createConfirmedSlice: StateCreator<
  ConfirmedSlice,
  [],
  [],
  ConfirmedSlice
> = () => ({
  confirmed: false,
});
